import { render, staticRenderFns } from "./ModalSaveSettings.vue?vue&type=template&id=407cd0a6&scoped=true"
import script from "./ModalSaveSettings.vue?vue&type=script&lang=js"
export * from "./ModalSaveSettings.vue?vue&type=script&lang=js"
import style0 from "./ModalSaveSettings.vue?vue&type=style&index=0&id=407cd0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cd0a6",
  null
  
)

export default component.exports